'use client';

import { useRouter } from 'next/navigation';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  /** Visual contrast variant — match the surrounding header background. */
  variant: 'light' | 'dark';
}

/**
 * Buton icon-only „← Înapoi" folosit în header-ele de sub-pagini.
 *
 * Click → router.back() din next/navigation. Folosit prin prop-ul `showBack`
 * din PageHeader; aceeași poziție pe orice stil de header (minimal/clean/
 * outline/solid-bar/gradient-linear/gradient-radial).
 *
 * Variantă:
 *   - light → pentru fundaluri albe/light (text gri, hover bg-neutral-100)
 *   - dark  → pentru fundaluri color (text alb, hover bg-white/15)
 */
export function BackButton({ variant }: BackButtonProps) {
  const router = useRouter();
  const cls = variant === 'dark'
    ? 'text-white/85 hover:text-white hover:bg-white/15'
    : 'text-neutral-500 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-100 hover:bg-neutral-100 dark:hover:bg-neutral-800';
  return (
    <button
      type="button"
      onClick={() => router.back()}
      aria-label="Înapoi"
      title="Înapoi la pagina anterioară"
      className={'shrink-0 inline-flex items-center justify-center h-10 w-10 rounded-md transition-colors ' + cls}
    >
      <ArrowLeft className="h-6 w-6" strokeWidth={2.75} />
    </button>
  );
}
